import allowedNtids from "../data/allowedNtids.json";

const allowedNtidSet = new Set(allowedNtids.map(ntid => ntid.toLowerCase()));

export const normalizeAllowedNtid = (value) => {
  if (typeof value !== "string") return "";
  const trimmed = value.trim();
  if (!/^[A-Za-z]{3}[0-9]{5}$/.test(trimmed)) return "";
  const normalized = trimmed.toLowerCase();
  return allowedNtidSet.has(normalized) ? normalized : "";
};

export const isAllowedNtid = (value) => normalizeAllowedNtid(value) !== "";
